const services = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <rect x="2" y="3" width="20" height="14" rx="2"/>
        <path d="M8 21h8M12 17v4"/>
      </svg>
    ),
    tag: "Development",
    title: "Website Development",
    desc: "Custom websites built for e-commerce stores, company branding, landing pages and web applications. Modern frameworks, fast performance, and responsive design on every device.",
    highlight: true,
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
      </svg>
    ),
    tag: "Marketing",
    title: "Digital Marketing",
    desc: "End-to-end digital marketing strategy — market research, content planning, brand positioning, campaign execution and full performance analytics.",
    highlight: false,
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <circle cx="11" cy="11" r="8"/>
        <path d="M21 21l-4.35-4.35"/>
      </svg>
    ),
    tag: "Advertising",
    title: "Google Ads & SEO",
    desc: "Google Search, Display and Shopping campaigns combined with on-page SEO to drive qualified organic and paid traffic that converts into real customers.",
    highlight: false,
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path d="M17 2H7a5 5 0 000 10h10a5 5 0 000-10z"/>
        <path d="M7 12a5 5 0 000 10h10a5 5 0 000-10"/>
        <circle cx="7"  cy="7"  r="1" fill="currentColor"/>
        <circle cx="17" cy="17" r="1" fill="currentColor"/>
      </svg>
    ),
    tag: "Social Media",
    title: "Social Media Ads",
    desc: "Targeted advertising campaigns on Facebook, Instagram and TikTok. Compelling creatives, precise audience segmentation and continuous optimisation for maximum ROI.",
    highlight: false,
  },
];

const ServicesSection = () => (
  <section id="services" className="bg-[#131523] py-24 px-6 md:px-12 lg:px-20">
    <div className="max-w-7xl mx-auto">

      {/* Header */}
      <p className="text-[#f5c210] text-xs tracking-[0.2em] uppercase font-IBM mb-4">— Services</p>
      <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14">
        <h2 className="font-IBM font-bold text-white text-4xl md:text-5xl leading-tight">
          What I Offer
        </h2>
        <p className="text-gray-500 font-IBM text-sm max-w-xs mt-4 md:mt-0 leading-relaxed">
          Combining technical development with digital marketing for a complete online presence.
        </p>
      </div>

      {/* Cards grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
        {services.map((s, i) => (
          <div
            key={i}
            className={`rounded-xl p-7 border transition-all duration-300 hover:-translate-y-1 cursor-default ${
              s.highlight
                ? "bg-[#f5c210] border-[#f5c210]"
                : "bg-[#191b2a] border-[#1e2030] hover:border-[#f5c210]/40"
            }`}
          >
            <div className={s.highlight ? "text-[#0d0e18] mb-5" : "text-[#f5c210] mb-5"}>
              {s.icon}
            </div>
            <p className={`text-xs font-IBM tracking-widest uppercase mb-2 ${
              s.highlight ? "text-[#0d0e18]/60" : "text-[#f5c210]"
            }`}>
              {s.tag}
            </p>
            <h3 className={`font-IBM font-semibold text-lg mb-3 ${
              s.highlight ? "text-[#0d0e18]" : "text-white"
            }`}>
              {s.title}.
            </h3>
            <p className={`font-IBM text-sm leading-relaxed ${
              s.highlight ? "text-[#0d0e18]/70" : "text-gray-400"
            }`}>
              {s.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
